import { useTheme } from 'foundations-theming-specialty/utils';
import SVGIconBase from './SVGIconBase';
import { jsx as _jsx } from "react/jsx-runtime";
const BreezeAiIcon = props => {
  const theme = useTheme();
  return /*#__PURE__*/_jsx(SVGIconBase, Object.assign({
    "data-test-id": "vertical-nav-icon__breeze-ai"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      xmlns: "http://www.w3.org/2000/svg",
      d: "M31.03,15.54c-3.67,0-6.74-3.04-6.74-6.69,0-.26-.21-.46-.47-.46s-.47.21-.47.46c0,3.68-2.99,6.67-6.7,6.69h-.09V.96c0-.26-.21-.46-.47-.46h0c-.26,0-.46.21-.46.46,0,8.05-6.57,14.58-14.68,14.58-.26,0-.46.21-.46.46h0c0,.26.21.47.47.47,8,0,14.67,6.63,14.67,14.57h0c0,.26.21.46.46.46h.01c.25,0,.46-.21.46-.46v-14.58h.09c3.7.02,6.7,3.01,6.7,6.69,0,.26.21.46.47.46s.47-.21.47-.46c0-3.65,3.07-6.69,6.74-6.69.26,0,.47-.21.47-.46h0c0-.26-.21-.46-.47-.46Z",
      fill: theme.color['global-shell-icon-nav-item-default']
    })
  }));
};
export default BreezeAiIcon;